module.exports = __webpack_public_path__ + "static/media/first-workshop.fb776921.webp";